export default "/images/1d64d896969caf834ffd672b4eae883d.avif";